import Backbone from 'backbone'
import Parse from 'parse'
import BaseParseObject from './BaseParseObject'

'use strict'

export const SavedSetting = BaseParseObject.extend('SavedSettings', {
  update: function (data) {
    const acl = new Parse.ACL()

    if (!this.get('ACL')) {
      acl.setPublicReadAccess(false)
      acl.setReadAccess(Parse.User.current().id, true)
      acl.setWriteAccess(Parse.User.current().id, true)
      this.setACL(acl)
    }

    this.set({
      title: data.title,
      fileDescription: data.fileDescription,
      user: Parse.User.current()
    })

    if (data.skysetData) {
      this.set({
        skysetData: data.skysetData
      })
    }

    return this.save().then(
      (item) => {
        Backbone.trigger('savedSettings:updated', item)
      },
      (error) => {
        Backbone.trigger('errors:parseReturned', error)
      }
    )
  },

  delete: function () {
    this.set('deleted', true)
    return this.save().then(
      (result) => {
        Backbone.trigger('savedSetting:deleted', result)
      },
      (error) => {
        Backbone.trigger('errors:parseReturned', error)
      }
    )
  },

  displayInSkySafariWidget: function (ssww) {
    // Reset widget state before loading new settings
    ssww.reset()
    return ssww.settings.load(this.get('skysetData'), 400, 500)
  }

})

export default SavedSetting
